import { FeaturesPage } from "~/components/marketing/features";

export default function FeaturesRoute() {
  return <FeaturesPage />;
}
